import { createInput } from '@formkit/vue'
import { FormAutoComplete } from '#components'

export const AutoCompleteType = createInput(
  {
    $cmp: FormAutoComplete,
    props: {
      modelValue: '$_value',
      'onUpdate:modelValue': '$node.input',
      suggestions: '$suggestions',
      loading: '$loading',
      'onUpdate:suggestions': '$onUpdate:suggestions',
      onSearch: '$onSearch',
      placeholder: '$placeholder',
    },
  },
  {
    props: [
      'modelValue',
      'suggestions',
      'loading',
      'onUpdate:modelValue',
      'onUpdate:suggestions',
      'onSearch',
    ],
  },
)
